module.exports = __webpack_public_path__ + "static/media/capartdela.ab71aa0.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/capartdela.mp3
// module id = 22
// module chunks = 0